<template>
  <base-section
    id="registration-fees"
  >
    <v-container
    id="registration-fees-container"
    >
    <base-section-heading title="European Test Symposium Registration Process">
    <span style="color: red"><strong>ATTENTION: For any problems or questions related to the registration online form, please contact Bastien Deveautour (bastien.deveautour@cpe.fr) and Alberto Bosio (alberto.bosio@ec-lyon.fr)</strong></span> <br>
    <span style="color: red"><strong>NEWS: the registration for ETS23 is closed.</strong></span> <br>
      <!---
      You can find the website for the registration process <a
      disabled
      href="https://www.azur-colloque.fr/DR07/inscription/inscription/303"
      target="_blank"
      >
      here</a>. Please follow the instructions reported in this <a
      href="registration_guide.pdf"
      download
      >
      guide</a>.
      <br>
      <br>
      <v-btn
          href="https://www.azur-colloque.fr/DR07/inscription/inscription/303"
          target="_blank"
          rounded
          color="success"
          dark
          style="padding: 15px"
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          Registration Website
        </v-btn>
        <br>
        <br>
        <v-btn
          href="registration_guide.pdf"
          target="_blank"
          rounded
          color="primary"
          dark
          download
          style="padding: 15px"
        >
          <v-icon
            left
            dark
          >
            mdi-download
          </v-icon>
          Guide for Registration
        </v-btn>
        <br>
        <br>
        If you want to registrate <strong>only for workshops</strong>, you have to select Workshop Registration 0€ as category and then select the workshop you want to attend in the "extras" (see <a
        href="only_ws_registration.png"
        download
        >screenshot</a>).
        --->
    </base-section-heading>
      <base-section-heading title="European Test Symposium Registration Fees">
      </base-section-heading>
      <v-data-table
        :headers="headers"
        :items="features"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
      </v-data-table>
      <br>
      <br>
      <v-data-table
        :headers="headersExtra"
        :items="featuresExtra"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
      </v-data-table>
      <br>
      <br>
      <base-section-heading title="ETS Workshops Registration Fees">
      </base-section-heading>
      <v-data-table
        :headers="headers"
        :items="featuresWs"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
      </v-data-table>
      <br>
      <br>
      <base-section-heading title="TSS Registration Fees">
      </base-section-heading>
      <v-data-table
        :headers="headersTss"
        :items="featuresTss"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
      </v-data-table>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Supporters',
    data: () => ({
      supporterscontacts: [
        {
          title: 'Paolo Bernardi',
          src: require('@/images/committees/paolobernardi.jpg'),
          text: 'Politecnico di Torino, IT, paolo.bernardi@polito.it',
        },
        {
          title: 'Bastien Deveautour',
          src: require('@/images/committees/bastien.jpg'),
          text: 'INL/CPE, FR, bastien.deveautour@cpe.fr',
        },
      ],
      headers: [
        {
          text: 'Category',
          value: 'category',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Advance Registration (Extended to April 26)',
          value: 'advance',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Late/on-site Registration (after April 27)',
          value: 'late',
          sortable: false,
          align: 'left',
        },
      ],
      headersTss: [
        {
          text: 'Category',
          value: 'category',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Advance Registration (by April 30)',
          value: 'advance',
          sortable: false,
          align: 'left',
        },
        /*
        {
          text: 'Late/on-site Registration (after April 21)',
          value: 'late',
          sortable: false,
          align: 'left',
        },
        */
      ],
      headersExtra: [
        {
          text: 'Extra pages in proceedings for accepted posters',
          value: 'category',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Cost (only before February 22)',
          value: 'cost',
          sortable: false,
          align: 'left',
        },
      ],
      featuresExtra: [
        {
          category: 'Every additional page (max 2)',
          cost: '200€',
        },
      ],
      features: [
        {
        category: 'IEEE Member – in presence',
        advance: '600€',
        late: '730€',
        },
        {
        category: 'IEEE Member – on-line',
        advance: '352€',
        late: '352€',
        },
        {
        category: 'Non Member – in presence',
        advance: '700€',
        late: '830€',
        },
        {
        category: 'Non Member – on-line',
        advance: '462€',
        late: '462€',
        },
        {
        category: 'IEEE Student Member – in presence (Social Event Included)',
        advance: '385€',
        late: '450€',
        },
        {
        category: 'IEEE Student Member – on-line',
        advance: '110€',
        late: '110€',
        },
        {
        category: 'Student Non Member – in presence (Social Event Included)',
        advance: '495€',
        late: '580€',
        },
        {
        category: 'Student Non Member – on-line',
        advance: '165€',
        late: '165€',
        },
        {
        category: 'IEEE Life Member – in presence',
        advance: '363€',
        late: '430€',
        },
        {
        category: 'IEEE Life Member – on-line',
        advance: '110€',
        late: '110€',
        },
        {
        category: 'Unemployed – in presence',
        advance: '363€',
        late: '430€',
        },
        {
        category: 'Unemployed – on-line',
        advance: '110€',
        late: '110€',
        },
        {
        category: 'Guest/Partner at the Social Event',
        advance: '165€',
        late: '165€',
        },
      ],
      featuresWs: [
        {
        category: 'eARTS Workshop – in presence',
        advance: '250€',
        late: '350€',
        },
        {
        category: 'eARTS Workshop – on-line',
        advance: '165€',
        late: '165€',
        },
        {
        category: 'AI-Treats Workshop – in presence',
        advance: '250€',
        late: '350€',
        },
        {
        category: 'AI-Treats Workshop – on-line',
        advance: '165€',
        late: '165€',
        },
        {
        category: 'IMTR Workshop – in presence',
        advance: '250€',
        late: '350€',
        },
        {
        category: 'IMTR Workshop – on-line',
        advance: '165€',
        late: '165€',
        },
        {
        category: 'All access Workshops – in presence',
        advance: '400€',
        late: '500€',
        },
        {
        category: 'All access Workshops – on-line',
        advance: '330€',
        late: '330€',
        },
      ],
      featuresTss: [
        {
        category: 'Test Spring School Participation',
        advance: '407€',
        late: '350€',
        },
        {
        category: 'Test Spring School + ETS Participation',
        advance: '621.50€',
        late: '350€',
        },
        {
        category: 'Test Spring School Participation (Industrial)',
        advance: '693€',
        late: '350€',
        },
      ],
    }),
  }
</script>
